import realEstateImage from "../assets/images/case-studies/real-estate.jpg";
import healthcareImage from "../assets/images/case-studies/healthcare.jpg";
import educationImage from "../assets/images/case-studies/education.jpg";
import ecommerceImage from "../assets/images/case-studies/ecommerce.jpg";

const caseStudies = [
  {
    id: 1,
    slug: "encompass",
    client: "Encompass",
    industry: "Enterprise / Multi-brand",
    challenge:
      "Three acquired brands meant three disconnected sites, scattered content ownership and a slow ticket-based publishing process.",
    strategy:
      "Consolidate the front door, standardize the content model and give the marketing team direct control of the site experience.",
    execution:
      "Rebuilt the public experience on a single Webflow setup, streamlined the publishing flow and aligned the new brand architecture across teams.",
    servicesUsed: ["Digital Strategy", "Web Experience", "Content Systems"],
    results: [
      "3 websites consolidated in 5 months",
      "Publishing ownership restored to marketing",
      "Cleaner cross-brand navigation",
    ],
    featured: true,
    timeline: "5 months",
    image: realEstateImage,
    sourceTitle: "Webflow customer story — Encompass",
    sourceUrl: "https://webflow.com/customers",
  },
  {
    id: 2,
    slug: "greenhouse",
    client: "Greenhouse",
    industry: "B2B SaaS",
    challenge:
      "The marketing team needed more agility than the old CMS could give, especially for launch pages and conversion experiments.",
    strategy:
      "Move the site into a marketer-owned platform and improve the demo-request journey with faster iteration.",
    execution:
      "Migrated the public site to Webflow and streamlined page publishing so experiments could ship without dev bottlenecks.",
    servicesUsed: ["UX Strategy", "Conversion Design", "Website Operations"],
    results: [
      "Up to 40% conversion improvement on demo request pages",
      "Faster launch cycles for the marketing team",
      "Less dependency on engineering for updates",
    ],
    featured: true,
    timeline: "Platform migration",
    image: educationImage,
    sourceTitle: "Webflow customer story — Greenhouse",
    sourceUrl: "https://webflow.com/customers",
  },
  {
    id: 3,
    slug: "ionity",
    client: "IONITY",
    industry: "Automotive / Mobility",
    challenge:
      "A fast-growing European network needed a scalable web system that could support multiple markets without slowing the team down.",
    strategy:
      "Create a localized platform with stronger governance and a cleaner content workflow across regions.",
    execution:
      "Launched a Webflow Enterprise build with a reusable content system and market-level publishing control.",
    servicesUsed: ["Enterprise Web", "Localization", "Design Systems"],
    results: [
      "64% more active users",
      "24-market platform rollout",
      "Simplified regional publishing",
    ],
    featured: true,
    timeline: "24-market rollout",
    image: ecommerceImage,
    sourceTitle: "Webflow customer story — IONITY",
    sourceUrl: "https://webflow.com/customers",
  },
  {
    id: 4,
    slug: "talkspace",
    client: "Talkspace",
    industry: "Healthcare",
    challenge:
      "The team needed a faster way to publish campaign pages and a more cohesive digital presence for a trust-sensitive category.",
    strategy:
      "Give marketing more autonomy while keeping the interface clear, calm and easy to navigate.",
    execution:
      "Moved landing page operations into Webflow Enterprise and tightened the launch process for campaigns and experiments.",
    servicesUsed: ["Healthcare UX", "Landing Pages", "Growth Operations"],
    results: [
      "7x faster landing page publishing",
      "Updates shipped in hours instead of days",
      "More consistent campaign execution",
    ],
    featured: false,
    timeline: "Enterprise rollout",
    image: healthcareImage,
    sourceTitle: "Webflow customer story — Talkspace",
    sourceUrl: "https://webflow.com/customers",
  },
];

export default caseStudies;
